import { useCarousel } from './useCarousel'

/**
 * @typedef {Object} UseLoopEngage
 * @property {(variables: any) => Promise<any>} engage
 * @property {(mode: ToteEngagementMode) => string} getImageForMode
 */

/**
 * @param {({variables: any}) => Promise<void>} engage
 * @param {CarouselMap} carouselMap
 * @return {{engage: (variables: any) => Promise<any>, getImageForMode: (mode: ToteEngagementMode) => string}}
 */

export function useLoopEngage(engage, carouselMap) {
  const carousel = useCarousel(carouselMap)
  return {
    engage: async variables => {
      const { data } = await engage({ variables })
      carousel.rotate(data.device)
      return data
    },
    getImageForMode: mode => carousel.first(mode)
  }
}
